import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRespuesta } from '@app/models/ApiRespuesta.interface';
import { Documento } from '@app/models/documento';
import { catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { handleError } from '../tools/handle-error';

@Injectable({ providedIn: 'root' })
export class DocumentoService {
    private readonly url = environment.url + 'documento/';
    private readonly http = inject(HttpClient);

    insert(data: FormData) {
        return this.http.post<ApiRespuesta<Documento[]>>(this.url, data).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    findAll(params?: HttpParams) {
        return this.http.get<ApiRespuesta<Documento[]>>(this.url, { params }).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    updateActivo(id: string) {
        const dir = this.url + id;
        return this.http.patch<ApiRespuesta<Documento[]>>(dir, {}).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }
}
